<template>
  <div class="send-button">
    <IconButton icon="paper-plane" width="25px" height="25px" v-bind="$attrs" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import IconButton from "@/components/IconButton.vue";

export default defineComponent({
  name: "ChatSendButton",

  inheritAttrs: false,

  components: {
    IconButton
  }
});
</script>

<style lang="scss" scoped>
.send-button {
  display: flex;
  align-items: center;
}
</style>
